import { canvasFillStyled, canvasFonted, canvasTextCentered } from '../../../fun-js-lib/canvas'
import Rect from '../../../fun-js-lib/geometry/Rect'
import { drawZLine } from '../../canvasDraw'
import { drawTextLines } from '../draw-styled-text/draw-text-lines'
import { getLinesFonted } from '../draw-styled-text/line'
import { mainFrameRect } from '../rects'
import { nLinesInWorkDescription, workDescriptionLinesWidths } from '../texts'

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} linesColor 
 * @param {import('../../constructionLog').LogPage} page 
 */
export function drawWorkDescription (context, linesColor, page) {
  drawLabel(context, linesColor)
  drawContent(context, page)
  drawZIfNeed(context, page)
}

export function workDescriptionRect () {
  let frame = mainFrameRect()
  return Rect.plain({
    x: frame.x,
    y: frame.y + 250 + 360,
    w: 1790,
    h: labelBlockHeight() + baseLineInterval() * maxNLinesOnMainPageWorkDescription
  })
}

export const maxNLinesOnMainPageWorkDescription = 18

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} linesColor 
 */
function drawLabel (context, linesColor) {
  const text = 'ОПИС РАДА'
  const rect = labelBlockRect()
  canvasFillStyled(context, linesColor, () => {
    canvasTextCentered(context, text, rect, 30)
  })
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {import('../../constructionLog').LogPage} page 
 */
function drawContent (context, page) {
  let rect = workDescriptionMainPageContentRect()
  const font = contentFont(page.number)
  const lines = getLines(context, page)
  canvasFonted(context, font, () => {
    drawTextLines(context, lines, workDescriptionLinesRange(), rect, lineInterval())
  })
}

export const workDescriptionLinesRange = () => ({
  start: 0,
  end: maxNLinesOnMainPageWorkDescription
})

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {import('../../constructionLog').LogPage} page 
 */
function getLines (context, page) {
  const json = page.work_description
  console.log(json)
  const linesWidths = workDescriptionLinesWidths()
  const font = contentFont(page.number)
  const lines = getLinesFonted(context, json, linesWidths, font)
  return lines
}

function labelBlockRect () {
  let rect = workDescriptionRect()
  return Rect.plain({
    x: rect.x,
    y: rect.y,
    w: rect.w,
    h: labelBlockHeight()
  })
}

function contentBlockRect () {
  let rect = workDescriptionRect()
  return Rect.plain({
    x: rect.x,
    y: rect.y + labelBlockHeight(),
    w: rect.w,
    h: rect.h - labelBlockHeight()
  })
}

export function workDescriptionMainPageContentRect () {
  let rect = contentBlockRect()
  return Rect.plain({
    x: rect.x + 20,
    y: rect.y,
    w: rect.w - 40,
    h: rect.h
  })
}

function labelBlockHeight () {
  return 70
}

function baseLineInterval () {
  return 55.555
}

const startPageContentFont = '44px Arial'

export const normalWorkDescriptionFont = '44px Arial'

const lineInterval = () =>
  baseLineInterval()

/**
 * @param {number} pageNumber 
 */
export function contentFont (pageNumber) {
  return pageNumber === 1 ? startPageContentFont : normalWorkDescriptionFont
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {import('../../constructionLog').LogPage} page 
 */
function drawZIfNeed (context, page) {
  const nLines = nLinesInWorkDescription(context, page.work_description, page.number)
  if (nLines < maxNLinesOnMainPageWorkDescription) {
    let rect = workDescriptionMainPageContentRect()
    let textHeight = nLines * lineInterval()
    let yTopIndent = page.number === 1 ? 16 : 10
    let zRect = Rect.plain({
      x: rect.x,
      y: rect.y + textHeight + yTopIndent,
      w: rect.w,
      h: rect.h - yTopIndent - textHeight - 4
    })
    drawZLine(context, zRect)
  }
}